import {FormField, FormFieldType, SelectionOption} from 'lionheartland';

export class PutPlanFormFields {

    public name: FormField
    public period: FormField
    public project: FormField

    constructor() {

        this.name = new FormField(
          'name',
          'Name',
          null,
          FormFieldType.text,
          false,
        )
        this.period = new FormField(
          'period',
          'Period',
          'period',
          FormFieldType.pushedSelectionList,
          false,
        )
        this.project = new FormField(
          'project',
          'Project',
          'project',
          FormFieldType.pushedSelectionList,
          false,
        )

    }
}

const fields = new PutPlanFormFields()

export const putPlanFormFieldOptions: {[key: string]: FormField} = {
  name: fields.name,
  period: fields.period,
  project: fields.project,
};